import * as types from "../types/categorias";

const INITIAL_STATE = {
  filtro: {
    titulo: "",
  },
  page: 1,
  perpage: 10,
  total: 0,
  data: [],
  categoria: {},
  loading: false,
  subfiltro: {
    titulo: "",
  },
  subpage: 1,
  subperpage: 4,
  subtotal: 0,
  sublista: [],
  subcategoria: {},
  subloading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CATEGORIA:
      return { ...state, categoria: action.payload };
    case types.LOAD_CATEGORIAS:
      return { ...state, data: action.payload };
    case types.SET_PAGE_CATEGORIA:
      return { ...state, page: action.payload };
    case types.SET_PERPAGE_CATEGORIA:
      return { ...state, perpage: action.payload };
    case types.SET_TOTAL_CATEGORIA:
      return { ...state, total: action.payload };
    case types.LOADING_CATEGORIA:
      return { ...state, loading: action.payload };
    case types.SET_FILTRO_CATEGORIA:
      return {
        ...state,
        filtro: { ...state.filtro, ...action.payload },
      };
    case types.SET_SUBCATEGORIA:
      return { ...state, subcategoria: action.payload };
    case types.LOAD_SUBCATEGORIAS:
      return { ...state, sublista: action.payload };
    case types.SET_PAGE_SUBCATEGORIA:
      return { ...state, subpage: action.payload };
    case types.SET_PERPAGE_SUBCATEGORIA:
      return { ...state, subperpage: action.payload };
    case types.SET_TOTAL_SUBCATEGORIA:
      return { ...state, subtotal: action.payload };
    case types.LOADING_SUBCATEGORIA:
      return { ...state, subloading: action.payload };
    case types.SET_FILTRO_SUBCATEGORIA:
      return {
        ...state,
        subfiltro: {
          ...state.subfiltro,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
